import { all, fork } from "redux-saga/effects";

// layout
import LayoutSaga from "./layout/saga";

//public
import AccountSaga from "./auth/register/saga";
import oauthCallbackSaga from "./auth/organization/oauthCallback/saga";
import AuthSaga from "./auth/login/authSaga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import HorizontalLayoutSaga from "./horizontalLayout/saga";
import pwdSaga from "./auth/newPassword/pwdSaga";
import mailSaga from "./auth/verificationMail/mailSaga";
import detailSaga from "./auth/detail/detailSaga";
import resetPasswordSaga from "./auth/resetPassword/saga";
import candidateListSaga from "./auth/organization/candidates/list/saga";
import candidateCountSaga from "./auth/organization/candidates/count/saga";
import parsingResumeSaga from "./auth/resumeParsing/saga";
import updatePasswordSaga from "./auth/profile/updatepassword/updatePasswordSaga";
//bulk import
import bulkimportsaga from "./auth/bulkimport/bulkimportsaga";
// view candidate saga
import viewCandidateSaga from "./auth/organization/candidates/viewCandidate/saga";

//myteam
import getUsersSaga from "./auth/myteam/getUsersSaga";
import getUpdateUserSaga from "./auth/myteam/updateuser/getUpdateUserSaga";
import getAddNewUserSaga from "./auth/myteam/adduser/getAddNewUserSaga";

//dashboard
import getDashboardSaga from "./auth/organization/Dashboard/PublishedJobs/getDashboardSaga";
import matchingSaga from "./process/matching/matchingSaga";

//report issues page
import reportIssuesSaga from "./auth/issues/reportIssuesSaga";

import parsingJdSaga from "./auth/jdParsing/saga";
import jobCountSaga from "./auth/organization/jobs/count/saga";
import jobListSaga from "./auth/organization/jobs/list/saga";
// view job saga
import viewJobSaga from "./auth/organization/Job/viewJob/saga";
//recruiter saga
import RecruiterOrganizationSaga from "./auth/Recruiter/Organization/saga";
import RecruiterDetailSaga from "./auth/Recruiter/Profile/RecuriterDetailSaga";

//feedback
import submitFeedBackSaga from "./auth/feedback/submitFeedBackSaga";

//candidate interview feedback
import CandidateInterviewSaga from "./auth/feedback/CandidateInterviewFeedback/CandidateInterviewSaga";

import CandidateInterestSaga from "./auth/feedback/CandidateInterest/CandidateInterestSaga";
//career info
import careerInfoSaga from "./auth/Career/careerInfoSaga";

//schedule interview
import scheduleInterviewSaga from "./auth/organization/candidates/ScheduleInterview/scheduleInterviewSaga";

import getCandidateInterviewDetailsSaga from "./auth/organization/candidates/CandidateInterviewDetails/getCandidateInterviewDetailsSaga";

import getInterviewsSaga from "./auth/Interview/getInterviewsSaga";

import notificationSaga from "./auth/organization/notification/saga";

import templateConfigurationSaga from "./auth/organization/TemplateConfiguration/saga";

import openJobsSaga from "./auth/organization/candidates/openjobs/saga";

import myCompanySaga from "./auth/myCompany/myCompanySaga";
import AiMarkupSaga from "./auth/organization/AiModal/AiMarkupSaga";
import assesmentQuestionsSaga from "./auth/organization/AssesmentQuestions/saga";
import ManageAssessmentSaga from "./auth/Recruiter/ManageAssessment/ManageAssessmentSaga";
import documentsSaga from "./process/documents/saga";

//submit document
import submitDocumentSaga from "./auth/feedback/submitDocument/submitDocumentSaga";
import questionsSaga from "./auth/Questions/questionsSaga";
import AssessmentTestSaga from "./auth/feedback/AssessmentTest/AssessmentTestSaga";
//unsubscribed Email
import nonAuthenticatepagesSaga from "./nonAuthenticatePages/nonAuthenticatepagesSaga";
import migrationSaga from "./auth/Migration/migrationSaga";
import thirdPartAppSaga from "./auth/Config/ThirdPartApp/thirdPartAppSaga";

//domain management
import domainManagementSaga from "./auth/organization/DomainManagement/domainManagementSaga";
import managersSaga from "./auth/organization/Managers/managersSaga";

//hiredecision
import HireDecisionHandleSaga from "./auth/organization/HireDecision/HireDecisionHandleSaga";

//offer letters list
import OfferLetterListSaga from "./auth/organization/offerLetters/OfferLetterListSaga";
//verification documents lsiting page
import verificationDocSaga from "./auth/organization/DocumentVerificationDetails/verificationDocSaga";

//email template
import emailTemplateConfigurationSaga from "./auth/organization/EmailTemplate/saga";

//CAREER CONFIG
import CareerConfigSaga from "./auth/organization/CareerPopUp/CareerConfigSaga";
import zohoIntegrationSaga from "./auth/zohoIntegration/zohoIntegrationSaga";

import PrescreeningQuestionsSaga from "./auth/PrescreeningQuestions/PrescreeningQuestionsSaga";

import emailIntegrationSaga from "./auth/emailIntegration/emailIntegrationSaga";
//recruitment process sagas
import screenSaga from "./process/screen/screenSaga";
import mappingSaga from "./process/mapping/mappingSaga";
import shortlistSaga from "./process/shortlist/shortlistSaga";
import interviewSaga from "./process/interview/interviewSaga";
import hireSaga from "./process/hire/hireSaga";
import OfferSaga from "./process/offer/OfferSaga";
 import ProcessAssessmentDetailsSaga from "./process/assessments/ProcessAssessmentDetailsSaga";
 //reprot saga
 import reportSaga from "./auth/Reports/saga";
import timeLineSaga from "./process/timeline/timeLineSaga";
import getVideoResumeSaga from "./auth/candidate/videoResume/getVideoResumeSaga";
import screenDetailsSaga from "./process/Hiring-Process/Screen/screenDetailsSaga";
import shortlistDetailsSaga from "./process/Hiring-Process/Shortlist/shortlistDetailsSaga";
import assessmentDetailsSaga from "./process/Hiring-Process/Assessment/assessmentDetailsSaga";
import linkedinSaga from './auth/jobDistributation/Linkedin/saga'
import impersonateSaga from "./auth/Impersonate/impersonateSaga";
export default function* rootSaga() {
  yield all([
    //public
    fork(matchingSaga),
    fork(LayoutSaga),
    AccountSaga(),
    fork(oauthCallbackSaga),
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    fork(pwdSaga),
    fork(HorizontalLayoutSaga),
    fork(mailSaga),
    fork(detailSaga),
    fork(resetPasswordSaga),
    fork(candidateListSaga),
    fork(candidateCountSaga),
    fork(parsingResumeSaga),
    fork(bulkimportsaga),
    fork(viewCandidateSaga),
    fork(getUsersSaga),
    fork(getUpdateUserSaga),
    fork(getAddNewUserSaga),
    fork(getDashboardSaga),
    fork(reportIssuesSaga),
    fork(parsingJdSaga),
    fork(jobListSaga),
    fork(jobCountSaga),
    fork(viewJobSaga),
    fork(updatePasswordSaga),
    fork(RecruiterOrganizationSaga),
    fork(RecruiterDetailSaga),
    fork(submitFeedBackSaga),
    fork(CandidateInterviewSaga),
    fork(CandidateInterestSaga),
    fork(careerInfoSaga),
    fork(scheduleInterviewSaga),
    fork(getCandidateInterviewDetailsSaga),
    fork(getInterviewsSaga),
    fork(notificationSaga),
    fork(templateConfigurationSaga),
    fork(openJobsSaga),
    fork(myCompanySaga),
    fork(AiMarkupSaga),
    fork(assesmentQuestionsSaga),
    fork(ManageAssessmentSaga),
    fork(documentsSaga),
    fork(submitDocumentSaga),
    fork(questionsSaga),
    fork(AssessmentTestSaga),
    fork(nonAuthenticatepagesSaga),
    fork(migrationSaga),
    fork(thirdPartAppSaga),
    fork(domainManagementSaga),
    fork(managersSaga),
    fork(HireDecisionHandleSaga),
    fork(OfferLetterListSaga),
    fork(verificationDocSaga),
    fork(emailTemplateConfigurationSaga),
    fork(CareerConfigSaga),
    fork(zohoIntegrationSaga),
    fork(PrescreeningQuestionsSaga),
    fork(emailIntegrationSaga),
    fork(screenSaga),
    fork(mappingSaga),
    fork(shortlistSaga),
    fork(interviewSaga),
    fork(hireSaga),
    fork(OfferSaga),
    fork(ProcessAssessmentDetailsSaga),
    fork(reportSaga),
    fork(timeLineSaga),
    fork(getVideoResumeSaga),
    fork(screenDetailsSaga),
    fork(shortlistDetailsSaga),
    fork(assessmentDetailsSaga),
    fork(linkedinSaga),
    fork(impersonateSaga)
  ]);
}
